import ScreenHeader from 'components/ScreenHeader'
import ScreenContainer from 'components/ScreenContainer'

import fontConfig from 'resources/killi-icons/config.json'

const icons = (fontConfig?.glyphs.map((glyph) => glyph?.search?.[0]) ?? []).sort((a, b) => a.localeCompare(b))

const KilliIcons = () => (
  <ScreenContainer>
    <ScreenHeader title="Killi Icons" />
    <div className="row">
      {icons.map((iconName) => (
        <div key={iconName} className="col-sm-6 col-md-3">
          <i className={`killi-icon-${iconName}`} />
          <span>{iconName}</span>
        </div>
      ))}
    </div>
  </ScreenContainer>
)

export default KilliIcons
